export default {"src":"/_next/static/media/success.53b693d3.svg","height":227,"width":227,"blurWidth":0,"blurHeight":0};